import * as React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import AdminLayout from '@/pages/admin'
import Loading from '@/components/loading'


const { lazy, Suspense } = React
const Home = lazy(() => import( /* webpackChunkName:"home" */'@/pages/home'))
const SignIn = lazy(() => import( /* webpackChunkName:"signin" */'@/pages/signInUp'))
const SignUp = lazy(() => import( /* webpackChunkName:"signup" */'@/pages/signInUp/signUp'))
const Forgot = lazy(() => import( /* webpackChunkName:"signup" */'@/pages/signInUp/forgot'))


const Routes = () => {
  return <Router>
    <Suspense fallback={<Loading size="large"/>}>
      <Switch>
        <Route path="/" exact component={(props: any) => <Home {...props}/>}/>
        <Route path="/signin" exact component={(props: any) => <SignIn {...props}/>}/>
        <Route path="/signup" exact component={(props: any) => <SignUp {...props}/>}/>
        <Route path="/forgot" exact component={(props: any) => <Forgot {...props}/>}/>
        <Route path="/admin" component={(props: any) => <AdminLayout {...props}/>}/>
        <Redirect to="/"/>
      </Switch>
    </Suspense>
  </Router>
}

export default Routes